module.exports = __webpack_public_path__ + "static/media/844NorthAvenueNW_2018-07-09_206.b23598b7.jpg";